module.exports = __webpack_public_path__ + "img/join-05.07777420.jpg";